'use client';

import { resolveTimeZone } from '@/utils';

import { useSelectedStore } from './useSelectedStore';

/**
 * Timezone to use for store-scoped time logic (discount schedules, hours):
 * the selected store's `dispensary_time_zone`, or the default store's when
 * nothing is selected yet.
 */
export const useDispensaryTimeZone = (): string => {
  const { store } = useSelectedStore();
  return resolveTimeZone(store?.dispensary_time_zone);
};
